import React from 'react';

/** 云 RBP 子功能壳内「辅助模式」上下文值：控制各子页是否展示设计稿中的说明文案 */
export type RbpCloudSubFunctionAuxiliaryModeContextValue = {
    /** 为 true 时展示 Figma 定义的灰色说明文案 */
    auxiliaryModeEnabled: boolean;
    /** 切换辅助模式（顶栏开关绑定） */
    setAuxiliaryModeEnabled: (enabled: boolean) => void;
};

const defaultAuxiliaryModeContextValue: RbpCloudSubFunctionAuxiliaryModeContextValue = {
    auxiliaryModeEnabled: false,
    setAuxiliaryModeEnabled: () => {},
};

/**
 * 子功能管理页共用：顶栏开关写入，各 Tab 内容区读取（如自助点餐通用设置）。
 */
export const RbpCloudSubFunctionAuxiliaryModeContext =
    React.createContext<RbpCloudSubFunctionAuxiliaryModeContextValue>(defaultAuxiliaryModeContextValue);
